import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

const Elements = props => (
  <div>
    <Helmet>
      <title>idealkraft - Impressum</title>
      <meta name="description" content="Impressum (Anbieterkennzeichnung)" />
    </Helmet>

    <div id="main" className="alt">
      <section id="one">
        <div className="inner">
          <header className="major">
            <h1>Impressum</h1>
          </header>
          <section>
            <h2>Angaben gemäß § 5 TMG</h2>
            <h3>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV: Thomas Frütel
            </h3>
            <div className="contact-method">
              <span className="icon alt fa-home" />
              <h3>Anschrift</h3>
              <span>
                Bergwerksstraße 1a<br />
                47239 Duisburg<br />
                Deutschland
              </span>
              <span className="icon alt fa-envelope" />
              <h3>Email</h3>
              idealkraft@fruetel.de
            </div>
          </section>
        </div>
      </section>
    </div>
  </div>
)

export default Elements



// WEBPACK FOOTER //
// ./src/pages/impressum.js